export default __webpack_public_path__ + "static/media/background_upload.da63549e.png";